import { yupResolver } from "@hookform/resolvers/yup";
import { defaultFormValues as _defaultFormValues, schema } from "./constants";
import { StaffUserFormValues } from "./types";
import { FormProvider, useForm } from "react-hook-form";

export interface StaffUserFormProps {
  defaultFormValues?: Partial<StaffUserFormValues>;
  children?: React.ReactNode;
}
export const StaffUserForm = ({
  defaultFormValues,
  children,
}: StaffUserFormProps) => {
  const methods = useForm<StaffUserFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ..._defaultFormValues,
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
